import React from 'react';

function StaffMember(props) {
  const { profileImage, name, role } = props;

  return (
    <div className="staff-profile">
      <img alt="Profile" src={`http://cdn.alliancevirtual.com.br/files/profile/${profileImage}`} />
      <h2>{name}</h2>
      <h3>{role}</h3>
    </div>
  );
}

export default StaffMember;
